import { useRecoilCallback } from "recoil";
import { CreateNewStack, ShowShare, ShowStacks, ShowStacksDuringDemoMode } from "../state/stackAtoms";
import { ShowTknsPanelAtom } from "../state/tknsAtoms";
import { ShowFileUploader } from "../state/uiAtoms";

/**
 * Close every modal/panel that could sit on top of a tour. Called from the
 * ShowTour → reactour sync (TourControl in landscape, TourStateBridge in
 * portrait) so EVERY path into a tour is covered — the first-signup flow
 * enters via DemoMode with the presentations panel freshly opened by the
 * /unset route, and used to play the tour underneath it.
 */
export function useClosePanelsForTour() {
	return useRecoilCallback(
		({ set }) =>
			() => {
				set(ShowStacks, false);
				set(ShowStacksDuringDemoMode, false);
				set(CreateNewStack, false);
				set(ShowShare, false);
				set(ShowFileUploader, false);
				set(ShowTknsPanelAtom, false);
			},
		[],
	);
}
